import { useCallback, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { Dialog } from "primereact/dialog";
import TabHeader from "../common/TabHeader";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useSelector } from "react-redux";
import CheckboxInput from "../common/CheckBoxInput";
import FileInput from "../common/FileInput";
import { TEXT_NORMAL } from "../../style";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";

export default function DialogEditChapter({ visible, closeDialog, setChapters, ...props }) {
    const { requestAPI, showToast } = useAppContext();

    const [chapter, setChapter] = useState(props);
    const [loading, setLoading] = useState();

    const { chapter_types = [] } = useSelector((state) => state.stateTemplateConfig?.global);

    const editChapter = useCallback(() => {
        requestAPI({
            requestPath: `chapters`,
            requestMethod: "PATCH",
            requestPostBody: chapter,
            setLoading: setLoading,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Update Subject !", life: 2000 }),
            onResponseReceieved: (updatedChapter, responseCode) => {
                if (updatedChapter && responseCode === 200) {
                    showToast({ severity: "success", summary: "Updated", detail: "Subject Updated", life: 1000 });
                    setChapters((prev) => prev?.map((chapter) => (chapter?.id === updatedChapter.id ? updatedChapter : chapter)));
                    closeDialog(); //close the dialog
                } else showToast({ severity: "error", summary: "Failed", detail: "Failed To Update Subject !", life: 2000 });
            },
        });
    }, [requestAPI, chapter, showToast, setChapters, closeDialog]);

    return (
        <Dialog pt={{ content: { className: "overflow-y-auto" } }} header={`Edit Chapter`} visible={visible} className="w-11" onHide={closeDialog}>
            <TabHeader className="pt-3" title="Edit Chapter" />

            <FloatLabel className="mt-5">
                <InputText
                    value={chapter?.title || ""}
                    id="title"
                    className="w-full"
                    onChange={(e) => setChapter((prev) => ({ ...prev, title: e.target.value }))}
                    disabled={loading}
                />
                <label htmlFor="title">Title</label>
            </FloatLabel>

            <FloatLabel className="flex-1 mt-5">
                <Dropdown
                    className="w-full"
                    value={chapter_types?.find(({ id }) => id === chapter?.type)}
                    inputId="branch"
                    options={chapter_types}
                    optionLabel="title"
                    onChange={(e) => setChapter((prev) => ({ ...prev, type: e.value?.id }))}
                />
                <label htmlFor="branch">Type</label>
            </FloatLabel>

            <CheckboxInput
                className={"mt-3"}
                label={"Allow Test"}
                checked={!!chapter?.test_attainable}
                onChange={(checked) => setChapter((prev) => ({ ...prev, test_attainable: checked }))}
            />

            {!!chapter?.test_attainable && (
                <FileInput
                    className={"mt-3"}
                    label="Questions Sheet"
                    type="sheet"
                    cdn_url={chapter?.test_questions_pool}
                    setCDNUrl={(cdn_url) => setChapter((prev) => ({ ...prev, test_questions_pool: cdn_url }))}
                    disabled={loading}
                    pt={{
                        root: { className: TEXT_NORMAL },
                    }}
                />
            )}

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.UPDATE_CHAPTERS}>
                <Button className="mt-3" label="Edit Subject" severity="warning" loading={loading} onClick={editChapter} />
            </HasRequiredAuthority>
        </Dialog>
    );
}
